import * as R from 'ramda'
import moment from 'moment'
import { GetPackageElements, RemoveInvalidPackageElements } from './packageElements.types'

export const getPackageElements: GetPackageElements = R.compose(
  R.path(['ecomm', 'packageElements'])
)

export const removeInvalidPackageElements: RemoveInvalidPackageElements = packageElements => R.when(
  R.pipe(R.values, R.length, R.lt(0)),
  R.reject(elem => (!moment(elem.checkin).isAfter(moment(), 'day')))
)(packageElements)
